import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "p-3" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_ozg_nav_item = _resolveComponent("g-ozg-nav-item");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, { title: _ctx.label }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
                    return (_openBlock(), _createBlock(_component_g_ozg_nav_item, {
                        page: page,
                        "current-page": _ctx.currentPage,
                        key: page.name
                    }, null, 8, ["page", "current-page"]));
                }), 128))
            ])
        ]),
        _: 1
    }, 8, ["title"]));
}
